import { Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { mapStatusToText } from "../utils";
import { StatusTextBlock } from "./StatusTextBlock";

interface Props {
  params: {
    value: string;
  };
  showIcon?: boolean;
}

export const CaseStatusRenderer = ({ params, showIcon = false }: Props) => {
  if (typeof params.value !== "string") {
    return null;
  }
  const {
    displayText,
    iconType,
    iconColor = Colors.Neutral900,
  } = mapStatusToText(params.value) || {};

  if (iconType === undefined) {
    return null;
  }
  return (
    <>
      {showIcon ? (
        <Flex alignItems="center" gap={8} style={{ height: "100%" }}>
          <Icon
            type={iconType}
            color={iconColor}
            data-testid="case-status-icon"
            data-cy="case-status-icon"
          />

          <div>
            <StatusTextBlock
              primaryText={displayText}
              color={iconColor}
              paddingTop={Sizes.XS}
            />
          </div>
        </Flex>
      ) : (
        <>
          <StatusTextBlock primaryText={displayText} color={iconColor} paddingTop={Sizes.SM} />
        </>
      )}
    </>
  );
};
